import { forwardRef, type ReactElement, type Ref, type SVGProps } from 'react'

const HeartIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
): ReactElement => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M16 32C7.2 32 0 24.8 0 16C0 7.2 7.2 0 16 0C24.8 0 32 7.2 32 16C32 24.8 24.8 32 16 32ZM16 1.5C8 1.5 1.5 8 1.5 16C1.5 24 8 30.5 16 30.5C24 30.5 30.5 24 30.5 16C30.5 8 24 1.5 16 1.5Z"
    />
    <path
      d="M16 28C9.4 28 4 22.6 4 16C4 9.4 9.4 4 16 4C22.6 4 28 9.4 28 16C28 22.6 22.6 28 16 28ZM16 5.5C10.2 5.5 5.5 10.2 5.5 16C5.5 21.8 10.2 26.5 16 26.5C21.8 26.5 26.5 21.8 26.5 16C26.5 10.2 21.8 5.5 16 5.5Z"
    />
    <path
      d="M16.0002 22.5029C15.8002 22.5029 15.6002 22.4029 15.5002 22.3029C15.3002 22.1029 10.8002 18.1029 9.80021 16.8029C9.10021 15.9029 8.80021 14.6029 9.10021 13.5029C9.40021 12.2029 10.3002 11.1029 11.6002 10.5029C13.5002 9.60292 15.1002 10.7029 16.0002 11.4029C16.8002 10.7029 18.5002 9.60292 20.4002 10.5029C21.7002 11.1029 22.6002 12.2029 22.9002 13.5029C23.2002 14.7029 22.9002 15.9029 22.2002 16.8029C21.2002 18.2029 16.7002 22.2029 16.5002 22.3029C16.4002 22.4029 16.2002 22.5029 16.0002 22.5029ZM13.1002 11.6029C12.8002 11.6029 12.6002 11.7029 12.3002 11.8029C11.4002 12.2029 10.8002 12.9029 10.6002 13.8029C10.4002 14.5029 10.6002 15.3029 11.0002 15.9029C11.7002 16.8029 14.5002 19.4029 16.0002 20.8029C17.5002 19.4029 20.3002 16.8029 21.0002 15.9029C21.4002 15.3029 21.6002 14.6029 21.4002 13.8029C21.2002 12.9029 20.6002 12.2029 19.7002 11.8029C18.1002 11.1029 16.6002 12.9029 16.5002 12.9029C16.2002 13.2029 15.6002 13.2029 15.3002 12.9029C15.4002 12.8029 14.3002 11.6029 13.1002 11.6029Z"
    />
  </svg>
)

export default forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(HeartIcon)
